import * as d3 from 'd3'
import { CandleProps } from '../interface'

export const Candles = ({
  deltaIndex,
  data,
  heightTop,
  showCandles,
}: CandleProps) => {
  const svg = d3.select('.chart').select('svg').select('.candles')
  const candleG = svg.append('g')
  if (deltaIndex >= 26) {
    svg
      .data(data)
      .transition()
      .duration(500)
      .attr('transform', () => {
        const delta = (deltaIndex - 26) * 13
        return 'translate(-' + delta + ',0)'
      })
  }

  const width = 9
  candleG
    .selectAll('.bar')
    .data(data)
    .enter()
    .append('rect')
    .attr('class', 'bar')
    .attr('y', (d: any) => {
      return `${heightTop - d.y * (2 / 100)}`
    })
    .attr('transform', (d: any, i: any) => {
      const delta = showCandles ? deltaIndex * 13 : i * 13
      return d.rollOver
        ? `translate(${delta + 9}, ${2 * heightTop}) rotate(180)`
        : `translate(${delta}, 0)`
    })
    .attr('width', `${width}px`)
    .attr('height', (d: any) => {
      return showCandles ? '0px' : `${d.y}px`
    })
    .transition()
    .duration(500)
    .attr('height', (d: any) => {
      return !showCandles ? '0px' : `${d.y}px`
    })
    .attr('rx', '2px')
    .attr('fill', (d: any) => {
      return d.win ? 'url(#greenGrad)' : 'url(#grayGrad)'
    })
}
